import http from "./http";

function get_userList(data) {
  return http.post(`user_get`, data);
}
function addUserData(data) {
  return http.post(`user_add`, data);
}
function updateUserData(data) {
  return http.post(`update_userData`, data);
}
function deleteuserData(data) {
  return http.post(`user_delete`, data);
}

function changeUserPassword(data) {
  return http.post(`update_userPassword`, data);
}

function change_user_status(data) {
  return http.post(`bloclUser`, data);
}

// --------- thana level user -------------
function getThanauser(data) {
  return http.post(`getThana_user`, data);
}

function addThanaUser(data) {
  return http.post(`addThana_level_user`, data);
}

function updateThanaUser(data) {
  return http.post(`update_thanaUserData`, data);
}

function deleteThanaUser(data) {
  return http.post(`thanauser_delete`, data);
}

// ------------ vehicle allot code -----------------

function getUserListToAllot(data) {
  return http.post(`userList_for_assign`, data);
}

function fetchVehicleListForAllotment(data) {
  return http.post(`district_vehicleList_for_assign`, data);
}

function allotvehicledata(data) {
  return http.post(`VehicleAssignto_user`, data);
}

const UserService = {
  get_userList,
  addUserData,
  updateUserData,
  deleteuserData,
  changeUserPassword,
  change_user_status,
  getThanauser,
  addThanaUser,
  updateThanaUser,
  deleteThanaUser,
  getUserListToAllot,
  fetchVehicleListForAllotment,
  allotvehicledata
};

export default UserService;
